var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"app-content"},[_c('div',{staticClass:"app-title"},[_c('div',[_c('h1',[_c('font-awesome-icon',{attrs:{"icon":"history"}}),_vm._v("\n          "+_vm._s(_vm.$t('activityHistory'))+"\n        ")],1)])]),_c('client-log')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }